import { JetApp, plugins, EmptyRouter } from "webix-jet";
import { createState, link } from "jet-restate";

import views from "./export_views";
import en from "locales/en";

// services
import Backend from "./models/Backend";
import Local from "./models/Local";
import Operations from "./models/Operations";
import Progress from "./models/Progress";
import Prompt from "./models/Prompt";

export class App extends JetApp {
	constructor(config) {
		const state = createState({});
		const params = { state };
		if (config.compact) params.forceCompact = config.compact;

		const defaults = {
			router: EmptyRouter,
			version: VERSION,
			debug: DEBUG,
			start: "/top/users",
			roles: true,
			compactWidth: 1000,
			params,
		};

		super({ ...defaults, ...config });

		const dynamic = obj =>
			this.config.override ? this.config.override.get(obj) || obj : obj;
		this.setService("backend", new (dynamic(Backend))(this, this.config.url));
		this.setService("progress", new (dynamic(Progress))());
		this.setService("local", new (dynamic(Local))(this));
		this.setService("operations", new (dynamic(Operations))(this));
		this.setService("prompt", new (dynamic(Prompt))(this));

		this.use(
			plugins.Locale,
			this.config.locale || {
				lang: "en",
				webix: {
					en: "en-US",
				},
			}
		);
	}

	require(type, name) {
		if (type === "jet-views") return views[name];
		else if (type === "jet-locales") return locales[name];

		return null;
	}

	// for external users
	getState() {
		return this.config.params.state;
	}
}

webix.protoUI(
	{
		name: "usermanager",
		app: App,
		getState() {
			return this.$app.getState();
		},
		getService(name) {
			return this.$app.getService(name);
		},
		$init() {
			const state = this.$app.getState();
			for (let key in state) {
				link(state, this.config, key);
			}
		},
	},
	webix.ui.jetapp
);

// re-export for customization
const services = { Backend, Local, Operations, Progress, Prompt };
const locales = { en };
export { views, locales, services };
